module.exports = __webpack_public_path__ + "static/media/en.ea93689a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/en.png
// module id = 315
// module chunks = 0